import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import FormElementContainerResponsive from "../../../components/forms_builder/FormElementContainerResponsive";
import LeumitSelfMedicalInfo from "../../../components/Leumit_Patient_SelfOnboard/LeumitSelfMedicalInfo";
import LeumitSelfUpdateFiles from "../../../components/Leumit_Patient_SelfOnboard/LeumitSelfUpdateFiles";
import LeumitSelfOtherMedicalInfo from "../../../components/Leumit_Patient_SelfOnboard/LeumitSelfOtherMedicalInfo";


class PainSelfMedicalInfoTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabInternalView: 1,
            docWidth: document.body.offsetWidth,
        };
    }

    componentDidMount() {
        const self = this;
        window.addEventListener('resize', function () {
            self.setState({docWidth: document.body.offsetWidth})
        }, true);
    }

    onValueChange = (name, value) => {
        this.props.onValueChange(name, value)
    }
    onYesNoValueChange = (name, value) => {
        this.props.onYesNoValueChange(name, value)
    }
    onclickSetIsOtherMedicalDiagnosis = () => {
        this.props.onclickSetIsOtherMedicalDiagnosis()
    }
    onClickMedicationConditions = (value) => {
        this.props.onClickMedicationConditions(value)
    }
    onClickPatientAllergics = (value) => {
        this.props.onClickPatientAllergics(value)
    }
    onClickAddDeleteMedications = (index, event, id, type) => {
        this.props.onClickAddDeleteMedications(index, event, id, type)
    }
    addDeleteMedication = (func, index) => {
        this.props.addDeleteMedication(func, index)
    }
    addFileObj = (index, selectedCategory, selectedFile) => {
        this.props.addFileObj(index, selectedCategory, selectedFile)
    }

    deleteUploadedFile = (index) => {
        this.props.deleteUploadedFile(index)
    }
    deleteLeumitUploadedFile = (index,fileIndex,fileName) => {
        this.props.deleteLeumitUploadedFile(index,fileIndex,fileName)
    }

    saveSelectedFile = (selectedFile, index) => (
        this.props.saveSelectedFile(selectedFile, index)
    )

    changeTabInternalView = (view) => {
        let viewToChange = view === this.state.tabInternalView ? 0 : view
        this.setState({tabInternalView: viewToChange})
    }
    changeView = (view) => {
        this.props.changeView(view)
    }

    render() {
        let {t} = this.props
        let {docWidth} = this.state

        return (
            <div className={'patientForm-box-container'}>

                <FormElementContainerResponsive title={t('patient_self_boarding.Medical_information')}
                                                Component={LeumitSelfMedicalInfo}
                                                currentContainerView={1}
                                                tabInternalView={this.state.tabInternalView}
                                                docWidth={docWidth}
                                                changeTabInternalView={(view) => this.changeTabInternalView(view)}
                                                rest={{
                                                    onYesNoValueChange: (name, value) => this.onYesNoValueChange(name, value),
                                                    onValueChange: (name, value) => this.onValueChange(name, value),
                                                    entry: this.props.entry,
                                                    changeTabInternalView: (view) => this.changeTabInternalView(view),
                                                    docWidth: docWidth,
                                                    onClickPatientAllergics: (val) => this.onClickPatientAllergics(val),
                                                    patient_allergics: this.props.patient_allergics,
                                                    allergics: this.props.allergics,
                                                    onClickMedicationConditions: (value) => this.onClickMedicationConditions(value),
                                                    medicalConditions: this.props.medicalConditions,
                                                    medicalConditionsSelected: this.props.medicalConditionsSelected,
                                                    errors: this.props.errors,
                                                    t: (e) => this.props.t(e)
                                                }}/>

                <FormElementContainerResponsive title={t('patient_self_boarding.Other_Medical_information')}
                                                Component={LeumitSelfOtherMedicalInfo}
                                                currentContainerView={2}
                                                tabInternalView={this.state.tabInternalView}
                                                docWidth={docWidth}
                                                changeTabInternalView={(view) => this.changeTabInternalView(view)}
                                                rest={{
                                                    onYesNoValueChange: (name, value) => this.onYesNoValueChange(name, value),
                                                    onValueChange: (name, value) => this.onValueChange(name, value),
                                                    entry: this.props.entry,
                                                    errors: this.props.errors,
                                                    changeTabInternalView: (view) => this.changeTabInternalView(view),
                                                    docWidth: docWidth,
                                                    t: (e) => this.props.t(e)
                                                }}/>


                <FormElementContainerResponsive title={t('patient_self_boarding.upload_files')}
                                                SubTitle={t('patient_self_boarding.help')}
                                                Component={LeumitSelfUpdateFiles}
                                                currentContainerView={3}
                                                tabInternalView={this.state.tabInternalView}
                                                docWidth={docWidth}
                                                changeTabInternalView={(view) => this.changeTabInternalView(view)}
                                                rest={{
                                                    saveSelectedFile: (selectedFile, index) => this.saveSelectedFile(selectedFile, index),
                                                    deleteLeumitUploadedFile: (index,fileIndex,fileName) => this.deleteLeumitUploadedFile(index,fileIndex,fileName),
                                                    entry: this.props.entry,
                                                    addFileObj: (index, selectedCategory, selectedFile) => this.addFileObj(index, selectedCategory, selectedFile),
                                                    deleteUploadedFile: (index) => this.deleteUploadedFile(index),
                                                    onValueChange: (name, value) => this.onValueChange(name, value),
                                                    changeView: (view) => this.changeView(view),
                                                    docWidth: docWidth,
                                                    addedFilesList: this.props.addedFilesList,
                                                    otherForms: this.props.otherForms,
                                                    filesToUpload: this.props.filesToUpload,
                                                    filesErrorOnSave: this.props.filesErrorOnSave,
                                                    fileForms: this.props.fileForms,
                                                    errors: this.props.errors,
                                                    isUploadingFiles: this.props.isUploadingFiles,
                                                    t: (e) => this.props.t(e)
                                                }}/>
            </div>
        );
    }
}


const LeumitPainSelfMedicalInfoTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(PainSelfMedicalInfoTabComposed);

export default LeumitPainSelfMedicalInfoTab;

